import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "table-custom mb-3" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "text-xs font-bold color-blue-grey uppercase" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: " flex gap-3" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "font-bold text-white" }, "Approve", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "font-bold text-white" }, "Bayar", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_ListDataHjex = _resolveComponent("ListDataHjex")

  return (_openBlock(), _createBlock(_component_ListDataHjex, _mergeProps(_ctx.paramListData, { ref: "refListDataHjex" }), {
    content: _withCtx(({ dataItems }) => [
      _createVNode("table", _hoisted_1, [
        _createVNode("tr", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colums, (col, key) => {
            return (_openBlock(), _createBlock("th", { key: key }, [
              _createVNode("p", _hoisted_3, _toDisplayString(col), 1)
            ]))
          }), 128))
        ]),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(dataItems as _ctx.ITransDepositsRefunds[], (val, index) => {
          return (_openBlock(), _createBlock("tr", { key: index }, [
            _createVNode("td", null, [
              _createVNode("p", null, _toDisplayString(val.Fullname), 1)
            ]),
            _createVNode("td", null, [
              _createVNode("p", null, _toDisplayString(val.Email), 1)
            ]),
            _createVNode("td", null, [
              _createVNode("p", null, _toDisplayString(`Rp. ${_ctx.rupiahFormat(val.Nominal)}`), 1)
            ]),
            _createVNode("td", null, [
              _createVNode("div", _hoisted_4, [
                _createVNode("div", {
                  style: _ctx.statusAdmin(val.Status),
                  class: "px-2 py-1 rounded-md uppercase flex font-extrabold"
                }, _toDisplayString(_ctx.statusAdmin(val.Status).title), 5)
              ])
            ]),
            _createVNode("td", null, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", {
                  style: _ctx.statusFinance(val.Status),
                  class: "px-2 py-1 rounded-md uppercase flex font-extrabold"
                }, _toDisplayString(_ctx.statusFinance(val.Status).title), 5)
              ])
            ]),
            _createVNode("td", null, [
              _createVNode("div", _hoisted_6, [
                (val.Status.toLowerCase() === 'requested' && _ctx.checkPermission(_ctx.PermissionEnum.CanApvDeposit))
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      class: "p-button-sm btn-primary rounded-md",
                      onClick: ($event: any) => (_ctx.onChangeStatus(val))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (val.Status.toLowerCase() === 'approved' && _ctx.checkPermission(_ctx.PermissionEnum.CanPayDeposit))
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      class: "p-button-sm btn-primary rounded-md",
                      onClick: ($event: any) => (_ctx.onChangeStatus(val))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 16))
}